import type { OrthologBox, OrthologData, OrthologousGroup } from "../../types.ts";

// TODO: We should cleaning unused track. But we don't have the info yet.

/**
 * Merge orthologous data. We receive only chunks from each track worker.
 * This MUST be fast. It can handle thousands of members at every new pileup change.
 */
export function mergeOrthologs(orthologousGroups: OrthologousGroup[], newOrthologs: OrthologBox[], trackId: string) {
  const orthologMap = new Map<number, OrthologousGroup>();

  // Create map of existing groups for O(1) lookups
  // Only filter orthologs when necessary to avoid unnecessary work
  for (const group of orthologousGroups) {
    const needsFiltering = group.orthologs.some((o) => o.trackId === trackId);
    orthologMap.set(group.orthologId, {
      orthologId: group.orthologId,
      orthologs: needsFiltering ? group.orthologs.filter((o) => o.trackId !== trackId) : [...group.orthologs], // Create a copy to avoid modifying the original
    });
  }

  // Process new orthologs
  for (const ortholog of newOrthologs) {
    const { orthologId, ...rest } = ortholog;
    let group = orthologMap.get(orthologId);

    // Create new group if it doesn't exist
    if (!group) {
      group = { orthologId, orthologs: [] };
      orthologMap.set(orthologId, group);
    }

    const orthologs = group.orthologs;
    const existingIdx = orthologs.findIndex((o: OrthologData) => o.id === rest.id && o.trackId === trackId);

    // Either add new ortholog or update existing one
    if (existingIdx === -1) {
      orthologs.push({ ...rest, trackId });
    } else {
      orthologs[existingIdx] = { ...orthologs[existingIdx], ...rest, trackId };
    }
  }

  return Array.from(orthologMap.values());
}
